import { useFormContext } from "react-hook-form";
import { FIELDS_GROUP } from "components/DynamicFields/FieldsGroup";
import { TOOL_INFO_FIELDS } from "constants/fieldNames.constans";
import { REQUEST_TYPE_VALUES, TOOL_VALUES } from "constants/selects.content";
import type { FormValues } from "types/form.types";

export const FlexibleFields = () => {
  const { watch } = useFormContext<FormValues>();

  const toolName = watch(TOOL_INFO_FIELDS.serviceTool);
  const requestTypeName = watch(TOOL_INFO_FIELDS.serviceType);

  if (!toolName || !requestTypeName) {
    return null;
  }

  const toolValue = TOOL_VALUES[toolName];
  const requestTypeValue = REQUEST_TYPE_VALUES[requestTypeName];

  return <div key={`${toolName}-${requestTypeName}`}>{FIELDS_GROUP[toolValue]?.[requestTypeValue] ?? null}</div>;
};
